import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, watch } from 'vue';
import { useRouter } from '@blade/common/utils/useVueApi';
import { useMapStore } from '@blade-sxp/screen-new/store/map';
import moment from 'moment';
import SnapShot from '@blade-sxp/screen-new/components/screen-head/snapshot.vue';
import { MAP_ITEMS } from '@blade-sxp/screen-new/components/screen-head/const';
import Clock from '@blade/common/components/clock/index.vue';
import { getDefaultLogo, getWeather, setDashboard } from '@blade-sxp/screen-new/components/screen-head/utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    emits: ['snapDateChange'],
    setup(__props, { emit }) {
        const router = useRouter();
        const store = useMapStore();
        let path = ref(router.currentRoute.path);
        // 大屏logo
        const { defaultLogoUrl, defaultLogoName } = getDefaultLogo();
        // 大屏items
        const { mapItems } = setDashboard();
        const snapShot = computed(() => {
            const currItem = MAP_ITEMS.find((item) => item.path === path.value);
            return currItem?.snapShot;
        });
        // 定时刷新页面、获取天气数据
        let timeCount = 0; // 定时计数
        let { celsius, weather } = getWeather();
        const refreshTime = computed(() => {
            const choosedItem = mapItems.value?.find((item) => item.path === path.value);
            if (choosedItem?.refreshTime) {
                return choosedItem.refreshTime;
            }
            return '';
        });
        watch(() => store.minuteTimer, (val) => {
            timeCount++;
            if (!(timeCount % 10)) {
                // 10分钟更新一次
                timeCount = 0;
                ({ celsius, weather } = getWeather());
            }
            if (refreshTime.value && moment().format('HH:mm') === refreshTime.value) {
                // 大屏刷新页面
                location.reload();
            }
        });
        // 快照
        let snapTime = ref('');
        const freezeDay = computed(() => {
            return snapTime.value?.split(' ')[0];
        });
        const freezeTime = computed(() => {
            return snapTime.value?.split(' ')[1];
        });
        // 快照选择
        const snapDateChange = (time) => {
            snapTime.value = time;
            emit('snapDateChange', time);
        };
        // 大屏跳转
        const handleChange = (to) => {
            snapDateChange('');
            path.value = to;
            router.push({ path: to });
        };
        return { __sfc: true, router, store, emit, path, defaultLogoUrl, defaultLogoName, mapItems, snapShot, timeCount, celsius, weather, refreshTime, snapTime, freezeDay, freezeTime, snapDateChange, handleChange, SnapShot, Clock };
    }
});
